/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1GetTransportModelsResponse } from '../../entities/v1/GetTransportModelsResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1TransportModelModelSchema } from './transportModelModelSchema'
import { z } from 'zod'

export const v1GetTransportModelsResponseSchema = z.object({
  transport_models: z.array(z.lazy(() => v1TransportModelModelSchema)),
}) as unknown as ToZod<V1GetTransportModelsResponse>